import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Container } from 'reactstrap';

import { getFacetPosts, getMultipleProductPosts } from 'Api/Blog/blog-service';
import BlogPostsCard from 'Components/Cards/BlogPostsCard/BlogPostsCard';
import BlogPostItemList from 'Components/Utility/SEO/Blog/BlogPostItemList';
import SkeletonBlogPostCard from 'Components/Utility/Skeleton/SkeletonBlogPostCard';

const FacetBlogPosts = ({ siteTheme, slug, facet, hitSlugs, title }) => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    const loadPosts = async () => {
      const fetchedPosts = await getFacetPosts(facet, slug);

      if (fetchedPosts.length < 3 && hitSlugs.length && facet !== 'collections') {
        const productPosts = await getMultipleProductPosts(hitSlugs, 3);

        const fetchedPostIds = fetchedPosts.map(p => p.id);

        const newPosts = productPosts.filter(p => !fetchedPostIds.includes(p.id));

        fetchedPosts.push(...newPosts);
      }

      return setPosts(fetchedPosts);
    };

    loadPosts();
  }, [slug, facet]); // eslint-disable-line react-hooks/exhaustive-deps

  if (posts && posts.length === 0) {
    return false;
  }

  return (
    <Container className="homepage-blog-section">
      <div className="section-heading-container">
        <h2 className="h3">
          <FormattedMessage id="facet-search.blog-posts" defaultMessage="{topic} Blog Posts" values={{ topic: title }} />
        </h2>
      </div>
      {posts === null ?
        <Row>
          {[...Array(3)].map((post, i) => {
            const hideLast = (i > 1) ? 'd-none d-md-block' : '';
            return (
              <Col xs={12} sm={6} md={4} key={Math.random()} className={hideLast}>
                <SkeletonBlogPostCard hideIntro darkTheme={siteTheme === 'dark'} />
              </Col>
            );
          })}
        </Row>
        :
        <Row>
          <BlogPostItemList posts={posts} title={`${title} Blog Posts`} />
          {posts.slice(0, 3).map((post, i) => {
            const hideLast = (i > 1) ? 'd-none d-md-block' : '';
            return (
              <Col xs={12} sm={6} md={4} key={post.id + Math.random()} className={hideLast}>
                <BlogPostsCard
                  hideIntro
                  post={post}
                  darkTheme={siteTheme === 'dark'}
                  clickTrackingSection="HomePageBlogSection"
                  blogCardNameTag="h3"
                />
              </Col>
            );
          })}
        </Row>
      }
    </Container>
  );
};

FacetBlogPosts.propTypes = {
  siteTheme: PropTypes.string,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  facet: PropTypes.string.isRequired,
  hitSlugs: PropTypes.arrayOf(PropTypes.string),
};

FacetBlogPosts.defaultProps = {
  siteTheme: 'dark',
  hitSlugs: [],
};

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(FacetBlogPosts);
